import occInstance from '@/api/instances/occ.js';

const FamilyApi = {
  getFamilyById: async (id) => {
    const endpointUrl = `/families/${id}`;
    const {data: response} = await occInstance.get(endpointUrl);
    return response;
  },
};

export {FamilyApi};
